module.exports = __webpack_public_path__ + "img/holding.0de28e14.png";